import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-list`,
};

const strings = {
    SIZE: ['large', 'small', 'default'],
    LAYOUT: ['vertical', 'horizontal'],
    ALIGN: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch']
};

export { cssClasses, strings };